export namespace Toggles {

    export class Handler {

        public static toggleAvailable(toggleName: string) : boolean {

            const bodyElem = document.querySelector('body');
            if (!bodyElem) { return false; }
            const togglesJson = bodyElem.dataset.toggles;
            if (!togglesJson || togglesJson.length === 0) { return false; }
            const togglesArray = JSON.parse(togglesJson);
            return togglesArray.includes(toggleName);
        }
    }
}